"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CognitoFormToJSON = exports.CognitoFormFromJSONTyped = exports.CognitoFormFromJSON = void 0;
function CognitoFormFromJSON(json) {
    return CognitoFormFromJSONTyped(json, false);
}
exports.CognitoFormFromJSON = CognitoFormFromJSON;
function CognitoFormFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'token': json['token'],
    };
}
exports.CognitoFormFromJSONTyped = CognitoFormFromJSONTyped;
function CognitoFormToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'token': value.token,
    };
}
exports.CognitoFormToJSON = CognitoFormToJSON;
//# sourceMappingURL=CognitoForm.js.map